import { fromJS } from 'immutable';


import {
    egiftCardsSerializer,
    getCustomRewardCardRecipient,
    metaDataSerializer,
    shippingGroupSerializer
} from '../payment/capiOrderV4ItemSerializer';


import { orderMetaData, getConsumerFees } from '../payment/paymentSelectors';
import { getPaidDigitalItems, getShippingGroups } from '../item/itemSelectors';
import { getRequireRecipientEmailForPhysicalGift } from '../brand/brandSelectors';
import { getCustomRewardCardRecipients } from '../promo/promoSelectors';


export const PAYMENT_PLUS_PAYMENT_TYPE = 'paymentPlus';


export const paymentPlusPaymentDataHandler = paymentData => (
    fromJS(paymentData).merge({
        approved: true,
        paymentMethod: PAYMENT_PLUS_PAYMENT_TYPE,
        CAPI_URI_VERSION: 'v5'
    })
);

export const defaultFailureResponse = {
    status: 402,
    statusText: 'Payment Required',
    data: {
        errorCode: 'PAYMENT_REQUIRED',
        fieldErrors: []
    }
};

export const parseErrorResponse = response => ({
    httpCode: response.status,
    httpMessage: response.statusText,
    capiCode: response.data.errorCode,
    fieldErrors: response.data.fieldErrors
});

export const accumulateErrors = (fieldErrors) => {
    if (!fieldErrors) return [];
    const reducer = (accumulator, currentValue) => {
        const errorId = currentValue.get('errors').get(0);
        accumulator.push(errorId);
        return accumulator;
    };
    return fieldErrors.reduce(reducer, []);
};


export const cartSerializer = (
    metaData,
    digitalItems,
    shippingGroups,
    requireRecipientEmailForPhysicalGift,
    customRewardCardRecipients = undefined,
    fees = []
) => {
    const egiftCards = egiftCardsSerializer(
        digitalItems,
        '',
        '',
        requireRecipientEmailForPhysicalGift,
        fees,
    );

    const plasticItems = shippingGroups.map(group => shippingGroupSerializer(
        group,
        '',
        '',
        requireRecipientEmailForPhysicalGift,
        fees
    )).toList();

    let serializedCartData = metaDataSerializer(metaData)
        .merge({
            egiftCards,
            shippingGroups: plasticItems
        });

    
    
    serializedCartData = ['notifyOffers', 'loyaltyNumber']
        .reduce((map, key) => map.delete(key), serializedCartData);

    if (customRewardCardRecipients) {
        serializedCartData = serializedCartData.set(
            'customRewardCardRecipients',
            customRewardCardRecipients.map(
                recipient => getCustomRewardCardRecipient(fromJS(recipient))
            )
        );
    }
    return serializedCartData;
};


export const provideCartInformation = (state) => {
    const metaData = orderMetaData(state);
    const digitalItems = getPaidDigitalItems(state);
    const shippingGroups = getShippingGroups(state);
    const requireRecipientEmailForPhysicalGift = getRequireRecipientEmailForPhysicalGift(state);
    const customRewardCardRecipients = getCustomRewardCardRecipients(state);
    const fees = getConsumerFees(state);

    const cartInformation = cartSerializer(
        metaData,
        digitalItems,
        shippingGroups,
        requireRecipientEmailForPhysicalGift,
        customRewardCardRecipients,
        fees
    );

    return cartInformation;
};



export const serializeAddress = (address) => {
    
    Object.keys(address).forEach((key) => {
        if (address[key] === 'N/A') {
            delete address[key];
        }
    });
    return address;
};
